import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";


const WaterBearingApi = createApi({
    reducerPath: "core/parameter/waterbearing/groundwater",
    baseQuery: axiosBaseQuery,
    tagTypes: ["parameterGroundwaterWaterbearing"],
    endpoints: (builder) =>({
        parameterGroundWaterbearingFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['parameterGroundwaterWaterbearing'],
            query: (query = '') => ({
                url: "core/parameter/waterbearing/groundwater" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        parameterGroundWaterbearingCreate: builder.mutation({
            invalidatesTags: ['parameterGroundwaterWaterbearing'],
            query: (data)=>({url: "core/parameter/waterbearing/groundwater", method: "POST", data})
        }),
        parameterGroundWaterbearingUpdate: builder.mutation({
            invalidatesTags: ['parameterGroundwaterWaterbearing'],
            query: (data)=>({url: "/core/parameter/waterbearing/groundwater/"+data.id, method: "PUT", data})
        }),
    
        parameterGroundWaterbearingDelete: builder.mutation({
            invalidatesTags: ['parameterGroundwaterWaterbearing'],
            query: (id)=>({url: "/core/parameter/waterbearing/groundwater/"+id, method: "DELETE"})
        }),
    })
})

export const { useParameterGroundWaterbearingFindAllQuery, useParameterGroundWaterbearingCreateMutation, useParameterGroundWaterbearingUpdateMutation, useParameterGroundWaterbearingDeleteMutation } = WaterBearingApi;
export {WaterBearingApi};
